<script lang="ts" setup>
import UnlockedLockSvg from '@/assets/svg/lock-brown-16.svg?component';
import { DialogService } from '@/core/shared/dialog/dialog.service';
import { UpgradeToGoldVariant } from '@/core/shared/dialog/dialog.types';

withDefaults(
  defineProps<{
    shortLabel?: boolean;
  }>(),
  {
    shortLabel: false,
  },
);

const dialogService = new DialogService();

const handleClick = () => {
  dialogService.openUpgradeToGoldModal(UpgradeToGoldVariant.InterviewScheduling);
};
</script>

<template>
  <button
    @click="handleClick"
    class="flex h-7 items-center rounded-md border-2 border-gold px-2 text-xs font-bold text-gold-brown hover:bg-gold-bg-hover"
  >
    <UnlockedLockSvg class="mr-1.5 h-4 w-4" />
    <span class="whitespace-nowrap">{{ shortLabel ? 'Interview' : 'Schedule interview' }}</span>
  </button>
</template>
